import { canAfford } from '../utils';
import { useRemainingBudget } from './use-remaining-budget';

/**
 * Whether the user can add one more unit at `price` without their points balance going negative,
 * accounting for everything already in the cart. Gates against the *remaining* budget
 * (balance minus cart), not the raw balance — see `useRemainingBudget`.
 */
export const useCanAfford = (price: number) => {
  const { balance, remaining } = useRemainingBudget();
  return {
    balance,
    remaining,
    affordable: canAfford(remaining, price),
    shortfall: Math.max(0, price - remaining),
  };
};
